__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/23d88ac/_next/";